export default "__VITE_ASSET__CBxkDVPC__"